module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "flex flex-center",
    staticStyle: {
      "padding-top": "76px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nodata.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-text",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("还没有可以编辑的内容组件")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2519c195","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/noData.vue
// module id = 244
// module chunks = 49